import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.css";
import reportWebVitals from "./reportWebVitals";
import App from "./layouts/containers/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.debug))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
